module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBig.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBig.svg
// module id = 231
// module chunks = 0